import React from 'react'

import { Box, Grid } from '@mui/material'

import CampaignAds from './CampaignAds'
import CampaignCompanies from './CampaignCompanies'
import CampaignDetailsAdExchange from './CampaignDetailsAdExchange'
import CampaignDetailsSummary from './CampaignDetailsSummary'

type CampaignDetailsProps = {
  campaign: Record<string, any>
  campaignId: string
}

const CampaignDetails = ({ campaign: { details, adExchangeDetails }, campaignId }: CampaignDetailsProps) => (
  <div className="campaign-details">
    <Box sx={{ mb: '2rem' }}>
      <Grid container spacing={2}>
        <Grid size={{ sm: 6 }}>
          <CampaignDetailsSummary campaignId={campaignId} data={details} />
        </Grid>
        <Grid size={{ sm: 6 }}>
          <CampaignDetailsAdExchange data={adExchangeDetails} />
        </Grid>
        <Grid size={{ sm: 6 }}>
          <CampaignCompanies />
        </Grid>
        <Grid size={{ sm: 6 }}>
          <CampaignAds />
        </Grid>
      </Grid>
    </Box>
  </div>
)

export default CampaignDetails
